import { Suspense } from "react";
import { GlobalStyle } from "./assets/styles/GlobalStyles";
import { ColorContextProvider } from "./context/ColorContext";
import BatterySection from "./sections/BatterySection";
import CameraSection from "./sections/CameraSection";
import ColorSection from "./sections/ColorSection";
import DesignSection from "./sections/DesignSection";
import DisplaySection from "./sections/DisplaySection";
import HeroSection from "./sections/HeroSection";
import PhoneModel from "./sections/PhoneModel";
import PricingSection from "./sections/PricingSection";
import ProcessorSection from "./sections/ProcessorSection";
import { Quote } from "./sections/QuoteSection";

function App() {
  return (
    <>
      <GlobalStyle />
      <Quote />
      <PhoneModel />
      <HeroSection />
      <DesignSection />
      <DisplaySection />
      <ProcessorSection />
      <BatterySection />
      {/* ColorContextProvider chama useGLTF (suspende enquanto o modelo 3D
          carrega); sem esse limite ela depende do cache do PhoneModel já ter
          resolvido a mesma URL antes, o que é frágil (e falha, por exemplo,
          em testes ou no primeiro paint antes do cache aquecer). */}
      <Suspense fallback={null}>
        <ColorContextProvider>
          <ColorSection />
          <CameraSection />
          <PricingSection />
        </ColorContextProvider>
      </Suspense>
    </>
  );
}

export default App;
